import { Box, Button, Tooltip } from "@mui/material";
import { Wysiwyg } from "../../../components/wysiwyg/Wysiwyg";
import { FormatedField } from "../../../types/fields.types";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { useStore } from "../../../store/store";
import { useUpdateRecord } from "../../../api/useUpdateRecord";
import { setFieldsErrors } from "../../../utils/setFieldsErrors";
import { GroupsTitle } from "../../../components/groups/GroupsTitle";
import { FieldName } from "../../../components/groups/FieldName";
import { SelectInputField } from "../../../components/fieldsInputs/fields/SelectInputField";
import { renderFieldView } from "../../../components/fieldsViews/renderFieldView";

type IntakeFormAdditionalInfoProps = {
    item: any;
    entity: string;
    field: FormatedField | undefined;
    severityPatientField: FormatedField | undefined;
    refetch: () => void;
};
export const IntakeFormAdditionalInfo = ({
    item,
    entity,
    field,
    severityPatientField,
    refetch,
}: IntakeFormAdditionalInfoProps) => {

    const entityForm = useForm();
    const [isEditing, setIsEditing] = useState(false);
    const { notifications } = useStore();
    const updateRecord = useUpdateRecord();

    const onSubmitAditionalInfo = async (formData: any) => {
        try {
            await updateRecord.mutateAsync({
                entity: entity,
                data: formData,
                id: item.id,
            });
            notifications.setNotification({
                isOpen: true,
                message: `Registo atualizado com sucesso`,
                severity: "success",
            });
            if (refetch) {
                //@ts-ignore it needs "then" to prevent flickering upon refetch
                refetch().then(() => {
                    setIsEditing(false);
                });
            }
        } catch (error: any) {
            if (error?.response?.data?.errors) {
                setFieldsErrors(error.response.data.errors, entityForm);

                notifications.setNotification({
                    isOpen: true,
                    message: `Erro ao atualizar registo`,
                    severity: "error",
                });
            }
        }
    };

    const handleSwitchToEdit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        setIsEditing(true);
    };

    const handleCancelEdit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        entityForm.resetField("content");
        entityForm.resetField("severity_patient");
        setIsEditing(false);
    };

    return (
        <Box sx={{ backgroundColor: "#fff" }}>

        <Box p={4}>
            <GroupsTitle title={field?.headerName ?? field?.field ?? "Content"} />
            <Box component={"form"} onSubmit={entityForm.handleSubmit(onSubmitAditionalInfo)}>
                <Wysiwyg entityForm={entityForm} initialValue={item?.content} isDisabled={!isEditing} />
                {severityPatientField && (
                    <Box mt={2}>
                        {isEditing ? (
                            <Tooltip title="Apenas Prescritor pode editar" arrow>
                                <Box>
                                    <SelectInputField
                                        field={severityPatientField}
                                        value={item?.severity_patient}
                                        entityForm={entityForm}
                                    />
                                </Box>
                            </Tooltip>
                        ) : (
                            <>
                                <FieldName headerName={severityPatientField.headerName} />
                                {renderFieldView(severityPatientField, item, "group")}
                            </>
                        )}
                    </Box>
                )}
                <Box display="flex" flex={1} alignItems="center" justifyContent="right" paddingTop={4}>
                    {isEditing ? (
                        <Box display="flex" justifyContent="center" gap={4}>
                            <Button color="secondary" type="button" onClick={handleCancelEdit}>
                                Cancelar
                            </Button>
                            <Button type="submit">Gravar</Button>
                        </Box>
                    ) : (
                        <Button type="button" onClick={handleSwitchToEdit}>
                            Editar
                        </Button>
                    )}
                </Box>
            </Box>
        </Box>
        </Box>
    );
};
